import { render, staticRenderFns } from "./PlayerTable.vue?vue&type=template&id=09dd726e"
import script from "./PlayerTable.vue?vue&type=script&lang=js"
export * from "./PlayerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports